// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .wrapper--39A-X {\n  margin-top: 40px;\n}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "wrapper--39A-X"
};
module.exports = exports;
